<template>
  <input
    v-bind:id="id"
    v-bind:name="id"
    v-bind:disabled="disabled"
    v-on:change="onChange($event.target.value)"
    type="text"
    class="datepicker no-autoinit"
  />
</template>


<script>
import axios from "axios";
import M from "materialize-css";
import jquery from "jquery";
import API from "../api.js";

export default {
  props: {
    id: String,
    from: String,
    to: String,
    mindate: String,
    value: String,
  },

  data() {
    return {
      departure: "",
      destination: "",
      travels: [],
      disabled: true,
    };
  },

  watch: {
    value(value) {
      this.$el.value = value;
    },
    departure() {
      this.loadTravels();
    },
    destination() {
      this.loadTravels();
    },
  },

  mounted() {
    // close on overlay click
    jquery(this.$el)
      .parent()
      .delegate(
        ".modal-overlay",
        "click",
        function () {
          M.Datepicker.getInstance(this.$el).close();
        }.bind(this)
      );

    // Notice, when disabled and clicked
    jquery(this.$el.parentNode).on(
      "click",
      function () {
        // console.log(this.$el.disabled);
        // console.log(this.$el.getAttribute("disabled"));

        if (this.$el.disabled) {
          M.toast({
            displayLength: 1000,
            html: "Veuillez d'abord renseigner les destinations",
          });
        }
      }.bind(this)
    );

    this.$root.$on("cityChanged", () => {
      this.reset();
    });

    // preload current month
    this.loadTravels();

    this.$root.$on("input", (val) => {
      this.$el.value = val;
    });

    this.$root.$on("emit-travel", (departure, destination) => {
      // disabled if both cities are not set
      this.$el.disabled = !departure || !destination;

      // Saving departure & destination
      this[this.from] = departure;
      this[this.to] = destination;
    });

    M.Datepicker.init(this.$el, this.generate_options());
  },

  methods: {
    reset() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.$el.value = "";
      this.onChange("");
    },

    loadTravels() {
      let year;
      let month;

      if (!year) {
        year = jquery(this.$el).parent().find("select.orig-select-year").val();
      }

      if (!month) {
        month = parseInt(
          jquery(this.$el).parent().find("select.orig-select-month").val()
        );
      }

      if (!year || !month) {
        // preload first month at startup
        let dt = new Date();
        year = dt.getFullYear();
        month = dt.getMonth();
      }

      if (!this.departure || !this.destination || isNaN(month) || isNaN(year)) {
        return;
      }

      let datedebut = new Date(year, month, 1);
      let datefin = new Date(year, month, 0);
      datefin.setMonth(datefin.getMonth() + 12);

      //console.log(`loading ${datedebut.formatSGTM()}~${datefin.formatSGTM()}`);

      axios
        .get(API.travels, {
          params: {
            departure: this.departure,
            destination: this.destination,
            start_date: datedebut.formatSGTM(),
            end_date: datefin.formatSGTM(),
          },
        })
        .then((resp) => {
          if (resp.data !== null) {
            this.travels = this.travels.concat(resp.data.travels);
          } else this.reset();
        });
    },

    generate_options: function () {
      return {
        autoClose: true,
        minDate: new Date(new Date().setDate(new Date().getDate() + 1)), // now + 1 day
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)), // now + 1 year
        firstDay: 1,
        format: "dd/mm/yyyy",
        i18n: {
          done: "Ok",
          cancel: "annuler",
          clear: "effacer",
          months: [
            "janvier",
            "février",
            "mars",
            "avril",
            "mai",
            "juin",
            "juillet",
            "août",
            "septembre",
            "octobre",
            "novembre",
            "décembre",
          ],
          monthsShort: [
            "jan",
            "fév",
            "mars",
            "avr",
            "mai",
            "juin",
            "juil",
            "août",
            "sept",
            "oct",
            "nov",
            "déc",
          ],
          weekdays: [
            "dimanche",
            "lundi",
            "mardi",
            "mercredi",
            "jeudi",
            "vendredi",
            "samedi",
          ],
          weekdaysShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
          weekdaysAbbrev: ["D", "L", "M", "M", "J", "V", "S"],
        },
        disableDayFn: this.datepickerFilterDays,
        onSelect: this.localizeDateFormat,
        onDraw: this.initDateFormat,
      };
    },

    datepickerFilterDays(dt) {
      let dtstr =
        ("0" + dt.getDate()).slice(-2) +
        "/" +
        ("0" + (dt.getMonth() + 1)).slice(-2) +
        "/" +
        dt.getFullYear();

      let min = false;

      if (this.mindate) {
        min = new Date(Date.UTC(...this.mindate.split("/").reverse()));
        min.setMonth(min.getMonth() - 1);
        min = min.getTime() > dt.getTime();
      }

      return (
        this.travels
          .map((a) => a.date.split("-").reverse().join("/"))
          .indexOf(dtstr) === -1 || min
      );
    },

    localizeDateFormat(selectedDate) {
      var shortWeekdays = [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
      ];
      var shortMonths = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];
      var day = selectedDate.getDate();
      var weekday = shortWeekdays[selectedDate.getDay()];
      var month = shortMonths[selectedDate.getMonth()];

      var formattedDate = weekday + " " + day + " " + month;

      jquery(this.$el)
        .find(".datepicker-date-display .date-text")
        .text(formattedDate);
    },

    initDateFormat(datePicker) {
      if (typeof datePicker.date === "undefined") {
        var calendarDate =
          datePicker.dateTextEl.innerHTML +
          " " +
          datePicker.yearTextEl.innerHTML;
        var newDate = new Date(calendarDate);
        if (typeof newDate === "object") {
          this.localizeDateFormat(newDate);
        }
      } else {
        this.localizeDateFormat(datePicker.date);
      }

      // Adding change month event
      this.loadTravels();
    },

    get() {
      var instance = M.Datepicker.getInstance(this.$el);
      return instance.date;
    },

    onChange(value) {
      // retrieve code from date
      let v = value.split("/").reverse().join("-");
      let travel = this.travels.find((t) => t.date == v);
      //console.log("LOG SEATS : ".travel.available_seat!= null ? travel.available_seat : "NULL");
      this.$root.$emit("codedate", {
        // to record codeTrajet
        name: "code" + this.id,
        code: (travel !== undefined) ? travel.code : '',
        seats: travel ? travel.available_seat : null
      });
      this.$emit("input", value); // for v-model
    },
  },
};
</script>